interface GeneralReglesData {
  thematiques: string[];
  points: {
    1: string;
    2: string;
    3: string;
    4: string;
  };
}

interface Fin {
  solo: string;
  multi?: string;
}

interface ModesReglesData {
  mode: string;
  descript: string;
  instructions: string[];
  fin: Fin;
}

const generalReglesData: GeneralReglesData[] = [
  {
    thematiques: [
      "Maladie",
      "Modes de Transmission",
      "Prise en Charge",
      "Dépistage",
      "Prévention",
    ],
    points: {
      1: "Une question vrai ou faux",
      2: "Une question à choix multiple (2 choix)",
      3: "Une question à choix multiple (4 choix)",
      4: "Une question ouverte",
    },
  },
];

const modesReglesData: ModesReglesData[] = [
  {
    mode: "Entraînement",
    descript:
      "Le mode Entraînement permet de se familiariser avec le sujet de manière détendue, sans compétition.",
    instructions: [
      "Choisissez la thématique de votre question parmi les options proposées.",
      "Sélectionnez le niveau de difficulté entre 1 et 4.",
      "Répondez à la question à voix haute.",
      "Cliquez sur « Voir la réponse » pour découvrir la réponse correcte.",
      `Indiquez si votre réponse était correcte en cliquant sur « Oui » ou « Non ».`,
    ],
    fin: {
      solo: "Le jeu se termine lorsque le joueur répond à 5, 10 ou 20 questions au choix.",
    },
  },
  {
    mode: "Classique",
    descript:
      "Le mode Classique est compétitif, offrant une expérience dynamique et stimulante pour tester ses connaissances. **Il se joue en solo ou en multijoueur.**",
    instructions: [
      "Choisissez la thématique de votre question parmi les options proposées.",
      "Sélectionnez le niveau de difficulté entre 1 et 4.",
      "Répondez à la question à voix haute.",
      "Cliquez sur « Voir la réponse » pour découvrir la réponse correcte.",
      `Indiquez si votre réponse était correcte en cliquant sur « Oui » ou « Non ».`,
    ],
    fin: {
      solo: "Le jeu se termine lorsque le joueur a atteint les 20 points.",
      multi: "Le jeu se termine lorsqu’une équipe a atteint 20 points.",
    },
  },
  {
    mode: "Expert",
    descript:
      "Le mode Expert est une expérience de jeu imprévisible, mettant à l’épreuve la capacité des joueurs à répondre à une variété de questions aléatoires. **Il se joue en solo ou en multijoueur.**",
    instructions: [
      "Les questions sont posées aléatoirement parmi 5 thématiques.",
      "Le niveau de difficulté (entre 1 et 4) est également déterminé de manière aléatoire.",
      "Répondez à la question à voix haute.",
      "Cliquez sur « Voir la réponse » pour découvrir la réponse correcte.",
      `Indiquez si votre réponse était correcte en cliquant sur « Oui » ou « Non ».`,
    ],
    fin: {
      solo: "Le jeu se termine lorsque le joueur a atteint les 20 points.",
      multi: "Le jeu se termine lorsqu’une équipe a atteint 20 points.",
    },
  },
];

export { generalReglesData, modesReglesData };
